@if (shouldShowHeader()) {
  <div>
    <app-pop-up-cnpj [isGlobalCnpj]="true"></app-pop-up-cnpj>
    <app-guided-tour></app-guided-tour>
    <app-freemium-acabando></app-freemium-acabando>
    <app-notifications></app-notifications>
    <app-header-2>
      <app-toast-2></app-toast-2>
      @if (pharmaSyncService.visible$ | async) {
        <app-pharma-sync></app-pharma-sync>
      }
      <router-outlet></router-outlet>
    </app-header-2>
  </div>
} @else {
  <router-outlet></router-outlet>
}

<app-iza-bubble-host [show]="showIzaBubble()" />

